export const MENU = [
  {
    label: 'Giám sát',
    value: 'tracking',
    link: '/tracking',
    query: ''
  },
  {
    label: 'Lộ trình',
    value: 'routing',
    link: '/routing',
    query: ''
  },
  {
    label: 'Camera',
    value: 'camera',
    link: '/camera',
    query: 'page=1'
  }
];
